<template>
  <div class="loading-wrapper">
    <div v-if="status === 'isLoading'" class="loading-box">
      <div class="loading-img">
        <img class="loading-circle" src="@/images/loading/green_circle.png" />
      </div>
      <span>正在加载</span>
    </div>
    <div v-if="status === 'isLastPage'" class="finish-tips">已经到底了</div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * status枚举：isLoading: 正在加载中，isLastPage: 已经是最后一页
     */
    status: {
      type: String,
      default: 'isLoading'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
// 定义动画loadingRotate
@keyframes loadingRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-wrapper {
  height: 0.8rem;

  font-size: 0.22rem;
  color: #999999;
  @include flex(row, center, center);
  .loading-box {
    @include flex(row, center, center);
    .loading-img {
      width: 0.32rem;
      height: 0.32rem;
      margin-right: 0.12rem;
      .loading-circle {
        width: 0.32rem;
        height: 0.32rem;
        // 调用动画loadingRotate
        animation: loadingRotate 1s infinite linear;
      }
    }
  }
  .finish-tips {
    font-size: 0.2rem;
    color: #999;
  }
}
</style>
